import { Link, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard,
  BookOpen, 
  Users, 
  GraduationCap, 
  Handshake, 
  FolderOpen, 
  UserCheck,
  TrendingUp,
  ShoppingCart,
  LogOut
} from 'lucide-react';

export default function AdminLayout({ admin, onLogout, title, children }) {
  const location = useLocation();

  const menuItems = [
    { title: 'Dashboard', icon: LayoutDashboard, path: '/admin', testId: 'menu-dashboard' },
    { title: 'Formations', icon: BookOpen, path: '/admin/formations', testId: 'menu-formations' },
    { title: 'Apprenants', icon: Users, path: '/admin/apprenants', testId: 'menu-apprenants' },
    { title: 'Formateurs', icon: GraduationCap, path: '/admin/formateurs', testId: 'menu-formateurs' },
    { title: 'Partenariats', icon: Handshake, path: '/admin/partenariats', testId: 'menu-partenariats' },
    { title: 'Ressources', icon: FolderOpen, path: '/admin/ressources', testId: 'menu-ressources' },
    { title: 'Inscriptions', icon: UserCheck, path: '/admin/inscriptions', testId: 'menu-inscriptions' },
    { title: 'Commandes', icon: ShoppingCart, path: '/admin/commandes', testId: 'menu-commandes' },
    { title: 'Propositions', icon: Handshake, path: '/admin/propositions', testId: 'menu-propositions' },
    { title: 'Statistiques', icon: TrendingUp, path: '/admin/statistiques', testId: 'menu-statistiques' }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-violet-50 via-purple-50 to-fuchsia-50">
      {/* Header */}
      <header className="bg-white shadow-md border-b border-violet-100 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <Link to="/admin">
              <h1 className="text-2xl font-bold gradient-text cursor-pointer hover:opacity-80 transition-opacity">
                Insitumed
              </h1>
            </Link>
            <div className="flex items-center gap-4">
              <div className="text-right hidden sm:block">
                <p className="text-sm font-medium text-gray-700">
                  {admin?.full_name}
                </p>
                <p className="text-xs text-gray-500">{admin?.email}</p>
              </div>
              <button
                onClick={onLogout}
                className="flex items-center gap-2 px-4 py-2 bg-red-50 text-red-600 rounded-lg hover:bg-red-100 transition-colors"
                data-testid="admin-logout-button"
              >
                <LogOut size={18} />
                <span className="text-sm font-medium hidden sm:inline">Déconnexion</span>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Navigation */}
      <nav className="bg-white border-b border-gray-200 shadow-sm sticky top-[73px] z-30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex gap-1 overflow-x-auto">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`flex items-center gap-2 px-4 py-3 whitespace-nowrap border-b-2 transition-colors ${
                    isActive
                      ? 'border-violet-500 text-violet-600 bg-violet-50'
                      : 'border-transparent text-gray-600 hover:text-violet-600 hover:bg-violet-50'
                  }`}
                  data-testid={item.testId}
                >
                  <Icon size={18} />
                  <span className="text-sm font-medium">{item.title}</span>
                </Link>
              );
            })}
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {title && (
          <div className="mb-8">
            <h2 className="text-3xl font-bold text-gray-800" data-testid="page-title">{title}</h2>
          </div>
        )}
        {children}
      </main>
    </div>
  );
}